import React, { forwardRef } from 'react';
import Input, { PasswordInput } from '@strava/ui/Input';
import styles from './RegistrationInput.module.scss';
import { ThemeTypes } from '@strava/authentication-ui';
import clsx from '@strava/ui/clsx';

type RegistrationInputProps = React.ComponentPropsWithoutRef<'input'> &
  (
    | {
        // type just has to not be 'password' or string for the conditional to work
        type: 'email' | 'text';
        hidePasswordText?: string;
        showPasswordText?: string;
      }
    | {
        type: 'password';
        hidePasswordText: string;
        showPasswordText: string;
      }
  ) & {
    label: string;
    inputMessage?: string | null;
    errorMessage?: string | null;
    errorMessageTestId?: string;
    theme?: ThemeTypes;
  };

export const RegistrationInput = forwardRef<
  HTMLInputElement,
  RegistrationInputProps
>(
  (
    {
      label,
      id,
      type,
      inputMessage,
      errorMessage,
      errorMessageTestId,
      hidePasswordText,
      showPasswordText,
      theme = 'dark',
      ...props
    },
    ref
  ) => (
    <div className={styles.input}>
      <label htmlFor={id} className={clsx(styles.label, styles[theme])}>
        {label}
      </label>
      {type === 'password' ? (
        <PasswordInput
          className={styles.textInput}
          ref={ref}
          id={id}
          hidePasswordText={hidePasswordText}
          showPasswordText={showPasswordText}
          {...props}
        />
      ) : (
        <Input
          className={styles.textInput}
          ref={ref}
          id={id}
          type={type}
          {...props}
        />
      )}
      {inputMessage && !errorMessage && (
        <p className={clsx(styles.message, styles[theme])}>{inputMessage}</p>
      )}
      {errorMessage && (
        <div className={styles.error} data-testid={errorMessageTestId}>
          {errorMessage}
        </div>
      )}
    </div>
  )
);

export default RegistrationInput;
